import {Component} from '@angular/core';
import {Brands} from '@ox/typings';
import {AppConfigService} from '@ox/utils';

const takataEligibleMarket = ['us'];
const evBoltLinkEligibleBrands: Brands[] = ['chevrolet'];

@Component({
  selector: 'webu-recalls-header',
  templateUrl: './recalls-header.component.html'
})
export class RecallsHeaderComponent {
  constructor(private appConfig: AppConfigService) {}
  private brand: Brands = this.appConfig.bml?.brand;
  public showBoltLink = evBoltLinkEligibleBrands.includes(this.brand);
  public isTakataEligible = takataEligibleMarket.includes(this.appConfig.bml.market);
}
